import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TransitionSwitch } from 'react-router-v4-transition'
import { BrowserRouter, Route } from 'react-router-dom'
import withWorks from './hoc/withWorks'
import Header from './components/Header'
import Works from './components/Works'
// import Photos from './components/Photos'
import Transition from './components/Transition'
import worksAnim from './components/worksAnim'
// import photosAnim from './components/PhotosAnim'
// import Bio from './components/Bio'
import Contact from './components/Contact'
import staticAnim from './components/staticAnim'
import { handleFirstLoad } from './helpers'
import withWindowSize from './hoc/withWindowSize'

class App extends Component {
  constructor(props) {
    handleFirstLoad(props.works[0].slug)
    super(props)
  }

  render() {
    const { isMobile } = this.props
    const firstSlug = this.props.works[0].slug

    return (
      <BrowserRouter>
        <div className="App">
          <Header firstSlug={firstSlug} />

          <TransitionSwitch parallel={false}>
            <Route path="/works/:slug">
              <Transition
                timeline={worksAnim(firstSlug, isMobile)}
                exitTimeScale={3}
              >
                <Works />
              </Transition>
            </Route>

            {/* <Route path="/photos">
              <Transition
                timeline={photosAnim(isMobile)}
                exitTimeScale={3}
              >
                <Photos isMobile={isMobile} />
              </Transition>
            </Route>

            <Route path="/bio">
              <Transition
                timeline={staticAnim(isMobile, '.bio .content')}
                exitTimeScale={3}
              >
                <Bio />
              </Transition>
            </Route> */}

            <Route path="/contact">
              <Transition
                timeline={staticAnim(isMobile, '.contact .content')}
                exitTimeScale={3}
              >
                <Contact />
              </Transition>
            </Route>
          </TransitionSwitch>
        </div>
      </BrowserRouter>
    )
  }
}

App.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  works: PropTypes.arrayOf(PropTypes.shape({
    slug: PropTypes.string.isRequired,
  })).isRequired,
}

export default withWindowSize(withWorks(App))



// WEBPACK FOOTER //
// ./src/App.js